// AutoGenerated
export class KadroVeSesGrubuBilgiModel {
    kadroModelId!: string;
    altSesGrupModelId!: string;
    id!: string;
    olusturan!: string;
    olusturmaTarih!: Date;
    guncelleyen!: string | null;
    guncellemeTarih!: Date | null;
}